import Button from 'emerald-ui/lib/Button';
import OverlayTrigger from 'emerald-ui/lib/OverlayTrigger';
import Popover from 'emerald-ui/lib/Popover';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: OverlayTrigger, componentName: 'OverlayTrigger' }], 'OverlayTrigger'),
  description:
    'An OverlayTrigger controls the position and visibility of an element (overlay) with respect to another element (trigger).',
  codeSamples: [
    {
      title: 'Default',
      scope: { Button, OverlayTrigger, Popover },
      code: `<OverlayTrigger
  style={{ margin: '3px' }}
  placement="top"
  overlay={<Popover>This is a Popover</Popover>}
>
  <Button color="info">Show overlay</Button>
</OverlayTrigger>`,
    },
  ],
};
